import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import Grid from "@material-ui/core/Grid"
import { isEmpty } from "lodash"
import Button from "@material-ui/core/Button"
import update from "immutability-helper"
import { openSnackBar } from "../../actions/snack-bar"
import {
  toggleCreateCompanyDialog,
  createCompany,
} from "../../actions/companies"
import InputLabel from "@material-ui/core/InputLabel"
import Input from "@material-ui/core/Input"
import FormControl from "@material-ui/core/FormControl"
import MaskedPhoneInput from "../MaskedPhoneInput"
import AddressAutoComplete from "../AddressAutoComplete/index"
import { refreshToken, setUser } from "../../actions/authentication"
import { getUser } from "../../actions/users"

class CreateCompanyDialogComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      company: {
        name: "",
        phone: "",
        email: "",
        description: "",
        route: "",
        street_address: "",
        city: "",
        state: "",
        zip: "",
      },
      organizerPhone: "",
    }
  }
  handleClose = () => {
    this.props.dispatch(toggleCreateCompanyDialog())
  }
  clearState = () => {
    this.setState({
      company: {
        name: "",
        phone: "",
        email: "",
        description: "",
        route: "",
        street_address: "",
        city: "",
        state: "",
        zip: "",
      },
    })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    let newState = update(this.state, {
      company: {
        [fieldName]: { $set: value },
      },
    })
    this.setState(newState)
  }
  onAddressChange = place => {
    let updates = {}
    for (const key in place) {
      updates[key] = {
        $set: place[key] || "",
      }
    }
    this.setState(
      update(this.state, {
        company: {
          ...updates,
        },
      }),
    )
  }
  submit = () => {
    this.setState({
      savingCompany: true,
    })
    this.props
      .dispatch(createCompany(this.state.company))
      .then(res => {
        this.props.dispatch(refreshToken()).then(() => {
          this.props
            .dispatch(getUser(this.props.authenticatedUser.id))
            .then(res => {
              this.props.dispatch(setUser(res))
              this.props.dispatch(
                openSnackBar({
                  message: "Organization created",
                }),
              )
              this.setState({
                savingCompany: false,
              })
              this.handleClose()
            })
        })
      })
      .catch(err => {
        console.log(err)
        this.setState({
          savingCompany: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: "There was an error creating this organization",
          }),
        )
      })
  }
  render() {
    const { fullScreen, classes } = this.props
    return (
      <Fragment>
        <Dialog
          className={classes.editCompanyDialog}
          fullScreen={fullScreen}
          open={this.props.createCompanyDialogOpen}
          onClose={this.handleClose}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialogPaper,
            },
          }}
        >
          <form onSubmit={this.submit} autoComplete="off">
            <DialogContent className={classes.dialogContent}>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth className={classes.marginBottom}>
                    <InputLabel htmlFor="name">Organization Name</InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      name="name"
                      placeholder="Name"
                      value={this.state.company.name}
                      onChange={this.handleInputChange}
                      id="name"
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MaskedPhoneInput
                    placeholder="Phone"
                    name="phone"
                    defaultValue={this.state.company.phone}
                    value={this.state.company.phone}
                    onChange={this.handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth className={classes.marginBottom}>
                    <InputLabel htmlFor="email">Email</InputLabel>
                    <Input
                      type="email"
                      fullWidth
                      name="email"
                      placeholder="Email"
                      value={this.state.company.email}
                      onChange={this.handleInputChange}
                      id="email"
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <AddressAutoComplete
                    className={classes.autoComplete}
                    InputProps={{ label: "Enter Organization Address" }}
                    InputClasses={{
                      input: classes.placesAutoCompleteInputInput,
                    }}
                    onChange={this.onAddressChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="description">Description</InputLabel>
                    <Input
                      multiline
                      type="text"
                      fullWidth
                      name="description"
                      value={this.state.company.description}
                      onChange={this.handleInputChange}
                      id="description"
                      margin="none"
                      autoComplete="nope"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions
              className={classes.dialogActions}
              classes={{
                action: classes.dialogActionsAction,
              }}
            >
              <Button color="primary" onClick={this.handleClose} type="button">
                Close
              </Button>
              <LoadingButton
                color="secondary"
                buttonclicked={() => this.submit()}
                working={this.state.savingCompany}
                disabled={
                  (!isEmpty(this.state.form) && !this.state.form.valid) ||
                  this.state.savingCompany
                }
                type="button"
              >
                Save
              </LoadingButton>
            </DialogActions>
          </form>
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    createCompanyDialogOpen: state.companies.createCompanyDialogOpen,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog(),
)(CreateCompanyDialogComponent)
